import axios from "axios";

const apiClient = axios.create({
  baseURL:
    // process.env.REACT_APP_API_BASE_URL ||
    "https://gadites-admin-api-afajgphnbtgbg2cx.westeurope-01.azurewebsites.net/api/v1",
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Fetch a single article by ID
 * @param {number|string} id - The article ID
 * @returns {Promise<Object>} - The article data object
 */
export const fetchArticleById = async (id) => {
  const response = await apiClient.get(`/articles/${id}`);
  return response.data.data; // unwrap the { status, message, data } envelope
};
